import { filterErrorsByField } from 'Automations/automationEditor/utils'
import { Box, Grid } from '@sequencehq/core-components'
import { Fragment } from 'react'

import { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { InputSelectControlField } from 'Automations/nodeDefinitions/components'
import { ProductSelector } from '../../../../switch/components/GroupEditor/inputs/components/ProductSelector'
import {
  appendTestId,
  readValue,
  usePrimaryOperatorState
} from './ProductPropertyEditor.helpers'

/**
 * Editor used when no primary operator is selected yet. Renders only the
 * product picker and operator dropdown — the second row stays hidden until
 * the user picks DISCOUNT or HAS_DISCOUNT, at which point the router swaps
 * in the corresponding operator editor.
 */
export const NoOperatorEditor: ConditionPropertyEditorComponent = ({
  'data-testid': dataTestId,
  operator,
  value,
  onChange,
  operators,
  siblingConditions,
  validationErrors,
  focusOnInitialLoad
}) => {
  const { productId } = readValue(value)

  const { operatorOptions, primaryOperatorDisabled, onPrimaryOperatorChange } =
    usePrimaryOperatorState({
      operator,
      productId,
      operators,
      siblingConditions,
      onChange
    })

  return (
    <Fragment>
      <Grid
        gridTemplateColumns="1fr 1fr"
        gap="8px"
        gridTemplateAreas='"product operator"'
      >
        <Box gridArea="product">
          <ProductSelector
            data-testid={appendTestId(dataTestId, 'product')}
            value={productId ?? ''}
            onChange={selected =>
              onChange({ value: { productId: String(selected) } })
            }
            validationErrors={filterErrorsByField(
              validationErrors?.value,
              'productId'
            )}
            initiallyOpen={focusOnInitialLoad}
          />
        </Box>
        <Box gridArea="operator">
          <InputSelectControlField
            data-testid={appendTestId(dataTestId, 'operator')}
            placeholder="Select..."
            options={operatorOptions}
            value={operator ?? ''}
            disabled={primaryOperatorDisabled}
            onChange={onPrimaryOperatorChange}
            validationErrors={validationErrors?.operator}
          />
        </Box>
      </Grid>
    </Fragment>
  )
}
